// Others
import axiosClient from './axiosClient';
import { urlApiJob } from '~/utils/constants/apis';
import { IBodyUpdate } from '~/utils/interface/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IChangeStatusJob,
  IDetailJob,
  IFormJob,
  IFormJobCosting,
  IJobCostingDetail,
  IJobItemKanban,
  IJobs,
  IListJobItemResponse,
  IParamQueryJobDetail,
  IParamQueryJobKanban,
  IQueryParamJob,
  IQueryParamJobItem,
  IFormConvertJobToSchedule,
} from '~/utils/interface/jobs';
import { ITask } from '~/utils/interface/task';
import { IIncident } from '~/utils/interface/incident';
import { IActivity } from '~/utils/interface/activity';
import { IGetListNoteByJob } from '~/utils/interface/note';
import { IResponseChecklist } from '~/utils/interface/checklist';

const jobApi = {
  getListJob: (params: IQueryParamJob) => {
    const url = urlApiJob.getListJob;
    return axiosClient.get<IBaseResponse<IListDataResponse<IJobs[]>>>(url, { params });
  },

  getListJobKanban: (params: IParamQueryJobKanban) => {
    const url = urlApiJob.getListJobKanban;
    return axiosClient.get<IBaseResponse<IListDataResponse<IJobItemKanban[]>>>(url, { params });
  },

  getDetailJob: (params: IParamQueryJobDetail) => {
    const url = urlApiJob.getDetailJob(params);
    return axiosClient.get<
      IBaseResponse<
        | IListDataResponse<IIncident[]>
        | IListDataResponse<ITask[]>
        | IDetailJob
        | IGetListNoteByJob
        | IResponseChecklist
        | IListDataResponse<IActivity[]>
        | IJobCostingDetail
      >
    >(url, {
      params: params?.query,
    });
  },

  getListJobItem: (payload: IQueryParamJobItem) => {
    const { jobId, ...params } = payload;
    const url = urlApiJob.getListJobItem(jobId);
    return axiosClient.get<IBaseResponse<IListJobItemResponse>>(url, { params });
  },

  deleteJob: (id: string) => {
    const url = urlApiJob.deleteJob(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  createJob: (body: IFormJob) => {
    const url = urlApiJob.createJob;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateJob: (params: IBodyUpdate<IFormJob>) => {
    const { id, body } = params;
    const url = urlApiJob.updateJob(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  changeStatusJob: (params: IBodyUpdate<IChangeStatusJob>) => {
    const { id, body } = params;
    const url = urlApiJob.changeStatusJob(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  additionalExpense: (payload: IBodyUpdate<IFormJobCosting>) => {
    const { id, body } = payload;
    const url = urlApiJob.additionalExpense(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  convertJobToSchedule: (payload: IBodyUpdate<IFormConvertJobToSchedule>) => {
    const { id, body } = payload;
    const url = urlApiJob.convertJobToSchedule(id);
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default jobApi;
